import { AxiosPromise } from 'axios'
import { createTeamUserClient } from './createTeamUserClient'
import { createUser, removeUser, getUsers, updateUser, getUser } from './methods'
import { TeamUserClient as BaseTeamUserClient } from './types'
import { TeamUserClientOptions } from './types'

export default function TeamUserClient(options?: TeamUserClientOptions): TeamUserClient {
  const commonOptions = {}

  return createTeamUserClient({
    ...commonOptions,
    ...options,
    methods: {
      createUser,
      removeUser,
      updateUser,
      getUser,
      getUsers,
    },
  })
}

export type TeamUserClient = BaseTeamUserClient & {
  readonly createUser: (data: any) => AxiosPromise<any>,
  readonly removeUser: (userId: string) => AxiosPromise<any>,
  readonly getUser: (userId: string) => AxiosPromise<any>,
  readonly getUsers: () => AxiosPromise<any>,
  readonly updateUser: (userId: string, permissions: string) => AxiosPromise<any>
}
